import {env} from "../utils/environment";
import axios, { AxiosResponse, Method } from "axios";

const REQUEST_RETRY_CNT = 3;
export interface RequestParams<T, P> {
  method?: Method
  url: string
  data?: T
  params?: P
  retryCnt?: number
  requireAuth?: boolean
  timeout?: number
  token?: string
}

const instance = axios.create({
  baseURL: env.REACT_APP_API_BASE_URL || window.location.origin,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
})

export const request = async <R = unknown, T = unknown, P = unknown>({
  method = 'GET',
  data,
  params,
  url,
  retryCnt = REQUEST_RETRY_CNT,
  requireAuth = false,
  timeout,
  token
}: RequestParams<T, P>): Promise<AxiosResponse<R>> => {
  const headers: any = {}
  if (requireAuth) {
    if (!token) {
      throw new Error('request fail, authorization not ready.');
    }
    headers['Authorization'] = `Bearer ${token}`;
  }

  return await instance
    .request({
      url,
      method,
      headers,
      data,
      params,
      timeout,
      transformResponse: (res) => {
        if (typeof res === 'string') {
          try {
            const jsonData = JSON.parse(res)
            return jsonData;
          } catch (e) {
            console.error('json parse error')
            return res;
          }
        }
        return res;
      },
    })
};

export default request;
